import { useState, useEffect } from 'react';
import classNames from 'classnames';
import styles from './jobFormDescription.module.scss';
import formStyles from '../formColumns/forms.module.scss';
import requiredStyles from '../../styles/required.module.scss';
import { RadioButtonGroup } from '../radioButtonGroup/radioButtonGroup';
import { RadioGroup } from '../form/radioGroup';
import { CheckBoxGroup } from '../form/checkBoxGroup';
import { Quil } from '../form/quil';
import { SelectInput } from '../form/selectInput';
import { useWatch, useFormContext } from 'react-hook-form';
export const JobFormDescription = (props) => {
  const { register, setValue, getValues } = useFormContext();
  const {
    isFetchingPositionLevels,
    isFetchingEmpTypes,
    employmentTypes,
    positionLevels,
    durations,
    description = '',
    handleDurationType,
  } = props;
  const [descValue, setDescValue] = useState(description || '');
  const [open, setOpen] = useState(true);

  const employment_type_id = useWatch({ name: 'employment_type_id' });
  const currentDescription = useWatch({ name: 'description' });

  // Register the description field with react-hook-form
  useEffect(() => {
    register('description');
    
    // Initialize contentEditable with existing form value or description prop
    const initialValue = getValues('description') || description;
    if (initialValue) {
      const descElement = document.getElementById('job-description');
      if (descElement) {
        descElement.innerHTML = initialValue;
        setDescValue(initialValue);
      }
    }
  }, [register, getValues, description]);



  const handleDescChange = (e) => {
    let html = e.currentTarget.innerHTML;
    setDescValue(html);
    // Update the form value so it gets submitted
    setValue('description', html, { shouldValidate: true, shouldDirty: true });
  };
  const formatDesc = (command) => {
    const el = document.getElementById('job-description');
    if (!el) return;
    el.focus();
    document.execCommand(command, false, null);
  };

  return (
    <div className={classNames(styles.compCardContainer)}>
      <div
        className={classNames(styles.compCardTitleContainer)}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', paddingBottom: '3px' }}
        onClick={() => setOpen((o) => !o)}
      >
        <span className={classNames(styles.dividerTextLarge)}>JOB DETAILS</span>
        <span
          style={{
            fontSize: 32,
            userSelect: 'none',
            transition: 'transform 0.2s',
            transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
            color: '#9a9a9a',
            display: 'flex',
            alignItems: 'center',
            marginTop: '-4px'
          }}
        >
          ⌄
        </span>
      </div>
      <div className={classNames(styles.compCardContent)} style={{ display: open ? 'block' : 'none' }}>
        {/* EMPLOYMENT TYPE */}
        <span className={classNames(styles.inputTitle)}>Employment type</span>
        {isFetchingEmpTypes ? (
          <p>Loading...</p>
        ) : (
          <div className={classNames(styles.fieldWrapper, 'd-flex')}>
            <RadioGroup
              name="employment_type_id"
              options={employmentTypes}
              onChange={handleDurationType}
              type="radio"
            />
            <div className="d-flex align-self-end ms-sm-4 ms-auto">
              <SelectInput
                name="employment_duration_id"
                options={durations}
                placeholder="Select duration"
                disabled={employment_type_id != '3'}
              />
            </div>
          </div>
        )}
        {/* POSITION LEVEL */}
        <div className={classNames(formStyles.formInnerWrapper, 'form-inner-wrapper')}>
          <span className={classNames(styles.inputTitle)}>
            Position level
            <div className={classNames(styles.textSmall)}>
              What level or rank best describes this job position?
            </div>
          </span>
          {isFetchingPositionLevels ? (
            <p>Loading...</p>
          ) : (
            <div className={classNames(styles.fieldWrapper)}>
              <CheckBoxGroup
                classNameLabel="mb-2 positionLevelCheckbox"
                options={positionLevels}
                name="position_levels"
                type="checkbox"
              />
            </div>
          )}
        </div>

        {/* JOB DESCRIPTION */}
        {/* Job description */}
        <div className={styles.QuillEditor + ' my-4'} style={{ clear: 'both' }}>
          <label className={styles.clientDescriptionLabel} htmlFor="job-description">
            <small className="text-danger">* </small>
            Job description
            <span className={`d-block mb-3 ${styles.helperText}`}>Describe the job position</span>
          </label>
          <div className={styles.formatToolbar} style={{ marginBottom: 8 }}>
            <button type="button" className={styles.formatButton} style={{ fontWeight: 'bold' }} onClick={() => formatDesc('bold')}>B</button>
            <button type="button" className={styles.formatButton} style={{ fontStyle: 'italic' }} onClick={() => formatDesc('italic')}>I</button>
            <button type="button" className={styles.formatButton} style={{ textDecoration: 'underline' }} onClick={() => formatDesc('underline')}>U</button>
            <button type="button" className={styles.formatButton} onClick={() => formatDesc('insertOrderedList')}>1.</button>
            <button type="button" className={styles.formatButton} onClick={() => formatDesc('insertUnorderedList')}>&bull;</button>
          </div>
          <div
            className={styles.textareaBox}
            name="description"
            id="job-description"
            contentEditable
            suppressContentEditableWarning
            style={{ minHeight: 150, maxHeight: 200, overflowY: 'auto', outline: 'none', whiteSpace: 'pre-wrap' }}
            onInput={handleDescChange}
          />
          <small className="text-danger float-start" style={{ clear: 'both' }}>
            {/* If you use formState.errors, you can show errors here */}
          </small>
        </div>
      </div>
    </div>
  );
};
